import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  registerUserContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: theme.app.spacing.sm,
    [theme.breakpoints.up('sm')]: {
      '& div:nth-child(2)': {
        marginRight: theme.app.spacing.base,
        width: `calc(50% - ${theme.app.spacing.base}px)`,
      },
      '& div:nth-child(3)': {
        width: '50%',
      },
      '& div:nth-child(8)': {
        marginRight: theme.app.spacing.base,
        width: `calc(50% - ${theme.app.spacing.base}px)`,
      },
      '& div:nth-child(9)': {
        width: '50%',
      },
    }
  },

  registerUserLoading: {
    background: 'rgb(255 255 255 / 70%)'
  },

  registerUserShowPassword: {
    cursor: 'pointer',
    userSelect: 'none',
    width: '100%',
    marginLeft: 'auto',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginTop: '-15px',
    '& label': {
      cursor: 'pointer',
      color: theme.palette.primary.main
    }
  },

  registerUserButtonSave: {
    marginTop: 21,
    width: 112,
    '@media (max-width:565px)': {
      width: '100%',
    },
  },

  registerUserButtonCancel: {
    marginTop: 21,
    width: 112,
    backgroundColor: theme.app.colors.text.light,
    color: theme.palette.primary.main,
    border: `2px solid ${theme.palette.primary.main}`,
    '@media (max-width:565px)': {
      width: '100%',
    },
  },

  registerUserButtonPassword: {
    marginTop: 21,
    width: 140,
    '@media (max-width:565px)': {
      marginTop: 0,
      width: '100%',
    },
  },

  registerUserInput: {
    width: '100%',
  },

  registerUserButtonContainer: {
    display: 'flex',
    marginLeft: 'auto',
    alignItems: 'center',
    justifyContent: 'flex-end',
    '& button': {
      margin: '0 0 0 16px',
    },
    '@media (max-width:565px)': {
      width: '100%',
      alignItems: 'none',
      justifyContent: 'center',
      display: 'block',
      marginLeft: 0,
      '& button': {
        margin: '8px 0 0 0 ',
      },
    },
  },
}))
